(() => {
  const enhance = (article) => {
    const body = article.querySelector('[data-article-body]');
    const toc = article.querySelector('[data-article-toc]');
    if (!body || !toc || toc.dataset.ready) return;
    const headings = [...body.querySelectorAll('h2')];
    if (headings.length >= 3) {
      const list = toc.querySelector('ol');
      headings.forEach((heading, index) => {
        if (!heading.id) {
          const base = `guide-section-${index + 1}`;
          let id = base;
          let suffix = 2;
          while (document.getElementById(id)) id = `${base}-${suffix++}`;
          heading.id = id;
        }
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${encodeURIComponent(heading.id)}`;
        link.textContent = heading.textContent.trim();
        item.append(link);
        list.append(item);
      });
      toc.hidden = false;
    }
    body.querySelectorAll('.article-table-wrap').forEach((table) => {
      table.tabIndex = 0;
      table.setAttribute('role', 'region');
      const caption = table.querySelector('caption');
      table.setAttribute('aria-label', caption ? caption.textContent.trim() : toc.getAttribute('aria-label'));
    });
    toc.dataset.ready = 'true';
  };
  document.querySelectorAll('[data-journal-article]').forEach(enhance);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-journal-article]').forEach(enhance);
  });
})();
